// removed by extract-text-webpack-plugin
module.exports = {"newReference":"NewReference__newReference___3c52Z","title":"NewReference__title___bcSUZ","form":"NewReference__form___3MtGT","input":"NewReference__input___1r6xo","button":"NewReference__button___376Mk"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/memberModeration/components/references/newReference/NewReference.scss
// module id = 1715
// module chunks = 0